import { workspaceApi } from '../api';
import { createResourceStore } from './createResourceStore';

export const auditsStore = createResourceStore({
  key: 'workspace-audits',
  loader: async (params = {}) => {
    const res = await workspaceApi.audits(params);
    return res?.data || { items: [], summary: {}, filters: { auditors: [], customers: [] } };
  },
  ttl: 20000,
  initialState: {
    filters: {
      view: 'all',
      q: '',
      status: 'all',
      auditor_id: 'all',
      customer_id: 'all',
      audit_kind: 'all',
      subject_kind: 'all',
      sort_by: 'scheduled_date',
    },
  },
});

export function setAuditFilters(patch) {
  auditsStore.setState((current) => ({ filters: { ...(current.filters || {}), ...(patch || {}) } }));
}

export function resetAuditFilters() {
  auditsStore.setState({
    filters: {
      view: 'all',
      q: '',
      status: 'all',
      auditor_id: 'all',
      customer_id: 'all',
      audit_kind: 'all',
      subject_kind: 'all',
      sort_by: 'scheduled_date',
    },
  });
}

export function resetAuditStore() {
  auditsStore.reset();
}
